import clsx from "clsx";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

import { JsonParseError } from "~/helpers/json";

import labels from "../../../helpers/labels";
import FormLabel from "../../login/formLabel/FormLabel";
import Switch from "../../switch/Switch";
import JsonEditorLazy from "../../ui/jsonEditor/JsonEditorLazy";
import TextArea from "../../ui/textArea/TextArea";
import styles from "./styles.module.scss";

const allowedSymbols = {
  min: 1,
  max: 60,
};

interface ContentSchemaModalProps {
  editedSuggestion: {
    content: string;
    active: boolean;
  };
  setEditedSuggestion: (value: { content: string; active: boolean }) => void;
  rtl: boolean | null;
  lang: string | null;
  isJson?: boolean;
  jsonError?: JsonParseError | null;
  isEditorLoading?: boolean;
  onEditorLoadingChange?: (isLoading: boolean) => void;
}

const ContentSchemaModal = ({
  editedSuggestion,
  setEditedSuggestion,
  rtl,
  lang,
  isJson,
  jsonError,
  isEditorLoading,
  onEditorLoadingChange,
}: ContentSchemaModalProps) => {
  const { register, watch, control } = useForm({
    defaultValues: {
      final: editedSuggestion.content || "",
      active: editedSuggestion.active,
    },
  });

  const commentText = watch("final") || "";
  const isActive = watch("active");
  useEffect(() => {
    setEditedSuggestion({
      content: commentText,
      active: isActive,
    });
  }, [commentText, isActive, setEditedSuggestion]);

  return (
    <div className={styles.editSuggestionContent}>
      <form>
        <FormLabel label="Suggestion" />
        {isJson ? (
          <Controller
            name="final"
            control={control}
            render={({ field }) => (
              <JsonEditorLazy
                value={field.value}
                onChange={field.onChange}
                error={jsonError}
                onLoadingChange={onEditorLoadingChange}
              />
            )}
          />
        ) : (
          <div className={clsx({ ["rtl"]: rtl })} lang={lang || undefined}>
            <TextArea
              minRows={6}
              placeholder="Edit Suggestion"
              style={{ width: "100%" }}
              {...register("final", {
                minLength: {
                  value: allowedSymbols.min,
                  message: labels.MIN_CHARACTERS_REQUIRED(allowedSymbols.min),
                },
              })}
            />
          </div>
        )}
        <div className={styles.switchContainer}>
          <FormLabel label="Approve Changes " />
          <Switch
            checked={isActive}
            disabled={isEditorLoading}
            {...register("active")}
          />
        </div>
      </form>
    </div>
  );
};

export default ContentSchemaModal;
